import { Component } from '@angular/core';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-shift-group-placeholder-cell',
    templateUrl: './shift-group-placeholder-cell.component.html',
    styleUrls: ['./shift-group-placeholder-cell.component.scss'],
    standalone: false
})
export class ShiftGroupPlaceholderCellComponent implements ICellEditorAngularComp {
  value: string;
  agInit(): void {}
  getValue(): string {
    return this.value;
  }
}
